import { Component, OnInit, HostBinding, Input, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { LabelStyleDialogService } from '../label-style-dialog.service.';
import { LabelStyle } from 'src/app/types/LabelStyle';

@Component({
  selector: 'app-label-style-button',
  templateUrl: './label-style-button.component.html',
  styleUrls: ['./label-style-button.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LabelStyleButtonComponent implements OnInit {

  @Input() title = 'Label Style';
  @Input() viewOnly = 'false';
  @Input() style: LabelStyle = '';
  @Input() disabled = false;
  @Output() styleChange = new EventEmitter<LabelStyle>();


  get value(): LabelStyle {
    return this.style;
  }
  set value(style: LabelStyle) {
    this.style = style;
  }
  constructor(private labelSvc: LabelStyleDialogService) { }

  ngOnInit() {

  }
  Show() {
    if(this.disabled === true) return;
    const handler = (data) => {
      this.style = data;
      this.styleChange.emit(this.style);

    };

    this.labelSvc.Show(handler, this.style, this.viewOnly !== 'false');

  }

}
